/*
 * Copyright (c) 2024. Haodong JU
 */

import hillo from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { reservationLocalHost } from '@/model/dataLayer/api/newReservation/reservation'

const url = reservationLocalHost + '/settings/tableSpecialPrice/'

export async function saveSpecialPrice (item) {
  return (await hillo.jsonPost(url + 'save', {
    ...item,
    deviceId: await getCurrentDeviceId()
  }))
}

export async function deleteSpecialPrice (id) {
  return (await hillo.post(`${url}${id}/delete`, {}))
}

export async function getSpecialPrice () {
  return (await hillo.get(url + await getCurrentDeviceId(), {})).data
}
